import(/* webpackMode: "eager" */ "/codegiant/components/site-header.tsx")